import '../Roboto-Regular-normal.js'

import { invoiceAPI } from '../../api/services/invoice'
import { printInvoicesToOnePdf } from './createPDF.ts'

export function invoicePDF(invoiceId: number) {
  const fetchData = async () => {
    try {
      const response = await invoiceAPI.getInvoice(invoiceId)

      if (response.error) {
        return null
      }

      const data = response.data

      if (data) {
        return data
      }
    } catch {
      return null
    }
  }

  fetchData().then((invoice) => {
    if (invoice) {
      printInvoicesToOnePdf([invoice], `${invoice.invoice_number}.pdf`)
    }
  })
}
